// import moment from "moment";
// import React, { useEffect, useState } from "react";
// import { Col, Row } from "react-bootstrap";
// import {
//   FormGroup,
//   Button,
//   Modal,
//   ModalBody,
//   ModalFooter,
//   ModalHeader,
//   Form,
//   Input,
//   Label,
// } from "reactstrap";
// import {
//   CamersStatus,
//   ReductionTarget,
// } from "../../../../../Data/staticData/data";
// import CommonFIlterButton from "../../../../Common/commonFilterButton/CommonFIlterButton";

// const UpdateTargetModelNew = ({
//   data,
//   targetweek,
//   handleShow,
//   handleSave,
//   selectedAreas,
//   selectedMonth,
//   currentTarget
// }) => {
//   const [modal, setModal] = useState(true);
//   const [formData, setFormData] = useState({
//     target: "",
//   });
// console.log('databbb',data)
// console.log('databbb',data)
//   const toggle = () => {
//     setModal(!modal);
//     handleShow(!modal);
//   };
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     handleSave(formData?.target);
//     toggle();
//   };
//   useEffect(() => { 
//   setFormData({
//     target:currentTarget
//   })
// }, [currentTarget])

//   return (
//     <Modal
//       centered
//       isOpen={modal}
//       toggle={toggle}
//       keyboard={false}
//       backdrop="static"
//     >
//       <ModalHeader toggle={toggle}>
//         Update Target (Week {data?.current_week?.week})
//       </ModalHeader>
//       <Form
//         onSubmit={handleSubmit}
//         className="theme-form"
//         style={{ padding: "10px 20px" }}
//       >
//         <ModalBody>
//           <FormGroup>



//            { data?.last_week.alerts == 0 && data?.current_week.target == null ? 
//            <p style={{color:'red'}} className="m-0 p-0">Due to last week's alert being zero, the target can not be set.</p>
//             :
//             <>
//              <Label> Target </Label>
//             <CommonFIlterButton
//               data={ReductionTarget}
//               handleInputChange={(e) => {
//                 const val = e.target.value;
//                 setFormData({ ...formData, target: val });
//               }}
//               style={{ fontSize: 14, color: "black" }}
//               selectedItem={formData?.target}
//               firstOption={"Select Target"}
//               inputChangeOption={"current_target"} 
//             />
//             </>
//             }
//           </FormGroup>

//           {selectedAreas?.length > 0 ? (
//             <>
//               <p style={{ fontWeight: 500, fontSize: 16, marginBottom: 5 }}>
//                 Selected Areas
//               </p>
//               <Row>
//                 {selectedAreas
//                   ?.sort((a, b) => {
//                     if (a.area < b.area_id) return -1;
//                     if (a.area > b.area_id) return 1;
//                     return 0;
//                   })
//                   .map((item, index) => (
//                     <Col
//                       key={index}
//                       className="col-12 col-sm-6 col-md-6 col-lg-4 col-xxl-4 col-xxl-4"
//                       style={{ padding: "5px 12px" }}
//                     >
//                       <b style={{ fontWeight: 400 }}>{item?.area_id}</b>
//                     </Col>
//                   ))}
//               </Row>
//             </>
//           ) : null}
//         </ModalBody>
//         <ModalFooter>
//           <Button className="m-1" color="dark" onClick={toggle}>
//             Close
//           </Button>
//           { data?.last_week.alerts == 0 && data?.current_week.target == null ?null:
//           <Button className="m-1" color="primary" type="submit">
//             Save
//           </Button>
//           }
//         </ModalFooter>
//       </Form>
//     </Modal>
//   );
// };

// export default UpdateTargetModelNew;




import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Form,
    Label,
} from "reactstrap";

const UpdateTargetModelNew = ({
    targetPercentt,
    data,
    targetweek,
    handleShow,
    handleSave,
    selectedAreas,
    selectedMonth,
    currentTarget
}) => {
    const [modal, setModal] = useState(true);
    const [target, setTarget] = useState(0);
    console.log('targettt', target)
    console.log('currentTarget', currentTarget)

    const lastWeekAlerts = data?.last_week?.alerts ?? 0;

    const toggle = () => {
        setModal(!modal);
        handleShow(!modal);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleSave(target);
        toggle();
    };

    useEffect(() => {
        setTarget(lastWeekAlerts);
    }, [data]);

    const calculateReduction = () => {
        if (lastWeekAlerts === 0) return 0;
        console.log('lastweekalertslastweekalerts', lastWeekAlerts)
        const reduced = lastWeekAlerts - target;
        console.log('reducedreduced', reduced)

        const reductionPercentage = (reduced / lastWeekAlerts) * 100;
        console.log('reductionPercentage', reductionPercentage)
        return Math.max(0, Math.min(100, Math.round(reductionPercentage))); // 0% - 100% safe range
    };
    // useCallback(() => 
    //     calculateReduction = () => {
    //       if (lastWeekAlerts === 0) return 0;
    //       console.log('lastweekalertslastweekalerts', lastWeekAlerts);
    //       const reduced = lastWeekAlerts - target;
    //       console.log('reducedreduced', reduced);

    //       const reductionPercentage = (reduced / lastWeekAlerts) * 100;
    //       console.log('reductionPercentage', reductionPercentage);
    //       return Math.max(0, Math.min(100, Math.round(reductionPercentage))); // 0% - 100% safe range
    //     }, 
    //   [target]);

    return (
        <Modal
            centered
            isOpen={modal}
            toggle={toggle}
            keyboard={false}
            backdrop="static"
        >
            <ModalHeader toggle={toggle}>
                Update Target (Week {data?.current_week?.week})
            </ModalHeader>

            <Form onSubmit={handleSubmit} className="theme-form" style={{ padding: "10px 20px" }}>
                <ModalBody>


                    <>
                        <Label for="targetRange">Adjust Target (out of {lastWeekAlerts})</Label>

                        <input
                            id="targetRange"
                            type="range"
                            min={0}
                            max={lastWeekAlerts}
                            value={target}
                            onChange={(e) => setTarget(Number(e.target.value))}
                            className="form-range"
                        />

                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                            <span><b>Target:</b> {target}</span>
                            <span><b>Reduction:</b> {lastWeekAlerts === 0 ? '-100' : calculateReduction()}%</span>
                        </div>
                    </>


                    {selectedAreas?.length > 0 && (
                        <>
                            <p style={{ fontWeight: 500, fontSize: 16, marginTop: 20 }}>Selected Areas</p>
                            <Row>
                                {selectedAreas.sort((a, b) => a.area_id.localeCompare(b.area_id)).map((item, index) => (
                                    <Col key={index} className="col-6 col-md-4" style={{ padding: "5px 12px" }}>
                                        <b style={{ fontWeight: 400 }}>{item?.area_id}</b>
                                    </Col>
                                ))}
                            </Row>
                        </>
                    )}

                </ModalBody>

                <ModalFooter>
                    <Button className="m-1" color="dark" onClick={toggle}>
                        Close
                    </Button>
                
                        <Button className="m-1" color="primary" type="submit">
                            Save
                        </Button>
                    
                </ModalFooter>

            </Form>
        </Modal>
    );
};

export default UpdateTargetModelNew;

